import React from "react";
import { Navigate } from "react-router-dom";

const ControlEventReportsListComponent = React.lazy(
  () =>
    import(
      "../../../../../components/control-event-reports/components/list/page"
    ),
);
const ControlEventReportDetailComponent = React.lazy(
  () =>
    import(
      "../../../../../components/control-event-reports/components/detail/page"
    ),
);


export const controlEventReportsRoutes = [
  {
    path: "list",
    element: <ControlEventReportsListComponent />,
  },
  {
    path: "show/:hash",
    element: <ControlEventReportDetailComponent />,
  },
  {
    path: "show",
    element: <Navigate replace to="/control/events/list" />,
  },
  {
    path: "",
    element: <Navigate replace to="/control/events/list" />,
  }
];
